import React from 'react';
import { useTranslation } from 'next-i18next';
import { create, InstanceProps } from 'react-modal-promise';

import { IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';
import { Company } from 'lib/models/company';
import { StudentSociety } from 'lib/models/student-society';

import styles from './NotifyUserModal.module.scss';

type ModalInstanceProps = InstanceProps<void> & { organizationName: string; creatableForType: Company['type'] | StudentSociety['type'] };

const ModalInstance: React.FC<ModalInstanceProps> = ({ isOpen, onResolve, onReject, organizationName, creatableForType }) => {
  const [t] = useTranslation('opportunity');

  return (
    <Modal isOpen={isOpen} onRequestClose={onReject} contentClassName={styles.container}>
      <IconButton size="xsmall" iconName="close" className={styles['cancel-icon']} onClick={() => onReject()} />
      <p className={styles.emoji}>🔔</p>
      <p className={styles.title}>
        {creatableForType === 'company' ? t('notify-user-modal.title-for-company') : t('notify-user-modal.title-for-society')}
      </p>
      <p className={styles.detail}>{t('notify-user-modal.desc', { createdBy: organizationName })}</p>
      <ButtonV3 size="large" isFullWidth onClick={() => onResolve()}>
        {t('notify-user-modal.primary-cta')}
      </ButtonV3>
      <ButtonV3 size="large" onClick={() => onReject()} className={styles.secondary} color="secondary" isFullWidth>
        {t('notify-user-modal.secondary-cta')}
      </ButtonV3>
    </Modal>
  );
};

export const notifyUserModalInstance = create(ModalInstance);
